var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocDestinationBlankRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / navi / soc_destination_blank_red") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-navi-/-soc_destination_blank_red",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "soc_destination_blank",
    fill: "#FF0000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,5.99999995 L28,1.99999995 L20,1.99999995 L20,5.99999995 L14,5.99999995 L14,46 L34,46 L34,5.99999995 L28,5.99999995 Z M32,44 L16,44 L16,7.99999997 L32,7.99999997 L32,44 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocDestinationBlankRed);
export default __webpack_public_path__ + "static/media/soc_destination_blank_red.87623c90d48c89c50ae205369a6ef0a5.svg";
export { ForwardRef as ReactComponent };